import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type TrackersContentState = {
    trackersContent: any;
    loading: boolean;
    error: any;
};

const initialState: TrackersContentState = {
    trackersContent: null,
    loading: false,
    error: null,
};

const host = window?.location?.host;
const file = "trackers-content.json";

export const getTrackersContent = createAsyncThunk(
    "get/trackers/content",
    async () => {
        try {
            const response = await useFetchAemBrspdContents({
                [ApiUrls.aem_content]: `${file}?appName=${host}`,
            });
            return response?.data;
        } catch (error) {
            throw error;
        }
    }
);

const trackersSlice = createSlice({
    name: "trackers-content/Details",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTrackersContent.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getTrackersContent.fulfilled, (state, action) => {
            state.trackersContent = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(getTrackersContent.rejected, (state, action) => {
            errorConditionGTM(
                "BRSPD_Tracker_EC_Flow",
                "tracker-content",
                action?.error?.message,
                action?.type
            );
            state.trackersContent = null;
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default trackersSlice.reducer;